import { RecuperarSenhaState } from "../../types/state.types";
import { StoreAction } from "../reduxTypes";
import * as actions from "./actions";

const initialState: RecuperarSenhaState = {
  dados: {
    email: "",
    cpf: "",
    dataNascimento: "",
    novaSenha: "",
    confNovaSenha: "",
    codigo: "",
  },
  dadosConfirmados: false,
  email: "",
};

const reducer = (
  state: RecuperarSenhaState = initialState,
  action: StoreAction
): RecuperarSenhaState => {
  switch (action.type) {
    case actions.RECUPERAR_SENHA__LIMPAR_DADOS:
      return initialState;

    case actions.RECUPERAR_SENHA__SET_DADOS:
      return {
        ...state,
        dados: action.payload,
      };

    case actions.RECUPERAR_SENHA__SET_EMAIL:
      let [email, dominio] = (action.payload as string).split("@");
      let aux = email[0];

      for (let i = 1; i < email.length - 1; i++) {
        aux += "*";
      }
      aux += email[email.length - 1];
      aux += "@";
      aux += dominio[0];
      for (let i = 1; i < dominio.length - 1; i++) {
        aux += "*";
      }
      aux += dominio[dominio.length - 1];

      return {
        ...state,
        email: aux,
      };

    case actions.RECUPERAR_SENHA__SET_DADOS_CONFIRMADOS:
      return {
        ...state,
        dadosConfirmados: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
